// Print mechanics for the PDF the Slate Pane's Flutter app posts to the dashboard: message check, browser test,
// hidden-frame print, new-tab print and the dev-only capture download. SlateIframe owns the state and the dialog.
export var PRINT_LOAD_TIMEOUT_MS = 10000;
export var PRINT_BLOCKING_MS = 1000;
export var PRINT_TAB_DELAY_MS = 500;
export var PRINT_CAPTURE_KEY = 'slatePrintCapture';

var FRAME_STYLE = 'position:fixed;left:0;top:0;width:1px;height:100px;opacity:0;border:0;pointer-events:none';

function isArrayBuffer(bytes) {
  return bytes instanceof ArrayBuffer || Object.prototype.toString.call(bytes) === '[object ArrayBuffer]';
}

export function isPrintPdfMessage(data) {
  if (!data || typeof data !== 'object') return false;
  if (data.kind !== 'slate' && data.kind !== 'entry') return false;
  if (typeof data.filename !== 'string' || typeof data.title !== 'string') return false;
  var bytes = data.bytes;
  if (!bytes || typeof bytes !== 'object') return false;
  if (!isArrayBuffer(bytes) && !ArrayBuffer.isView(bytes)) return false;
  return bytes.byteLength > 0;
}

export function printsInNewTab(userAgent, maxTouchPoints) {
  var ua = userAgent || '';
  if (/Android|iPhone|iPad|iPod/.test(ua)) return true;
  if (/Macintosh/.test(ua) && (maxTouchPoints || 0) > 1) return true;
  return /Safari/.test(ua) && !/Chrome|Chromium|Firefox|Edg/.test(ua);
}

export function isPrintCaptureOn(nodeEnv, getStorage) {
  if (nodeEnv !== 'development') return false;
  try {
    var storage = getStorage();
    return !!storage && storage.getItem(PRINT_CAPTURE_KEY) === '1';
  } catch (e) {
    return false;
  }
}

export function createPdfUrl(bytes) {
  return window.URL.createObjectURL(new Blob([bytes], {type: 'application/pdf'}));
}

export function printInFrame(url, handlers) {
  var done = false;
  var timer = null;
  var frame = document.createElement('iframe');

  function release() {
    done = true;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    if (frame.parentNode) frame.parentNode.removeChild(frame);
  }

  frame.setAttribute('style', FRAME_STYLE);
  frame.setAttribute('aria-hidden', 'true');
  frame.setAttribute('tabindex', '-1');
  frame.title = 'Print Preview Frame';
  frame.src = url;
  frame.addEventListener('load', function () {
    if (done) return;
    done = true;
    clearTimeout(timer);
    timer = null;
    var started = Date.now();
    try {
      frame.contentWindow.focus();
      frame.contentWindow.print();
    } catch (e) {
      handlers.onFail('print-threw');
      return;
    }
    var blocked = Date.now() - started > PRINT_BLOCKING_MS;
    handlers.onPrinted();
    if (blocked) {
      release();
      if (handlers.onReleased) handlers.onReleased();
    }
  });
  document.body.appendChild(frame);
  timer = setTimeout(function () {
    timer = null;
    if (done) return;
    done = true;
    handlers.onFail('load-timeout');
  }, PRINT_LOAD_TIMEOUT_MS);

  return {frame: frame, release: release};
}

export function openPdfTab(url) {
  var tab = window.open(url, '_blank');
  if (!tab) return null;
  var fired = false;
  try {
    tab.addEventListener('load', function () {
      if (fired) return;
      fired = true;
      setTimeout(function () {
        try { tab.focus(); } catch (e) { /* tab closed or cross-origin */ }
        try { tab.print(); } catch (e) { /* tab closed or cross-origin */ }
      }, PRINT_TAB_DELAY_MS);
    });
  } catch (e) { /* the PDF stays on screen for the user to print */ }
  return tab;
}

export function downloadPdf(url, filename) {
  var link = document.createElement('a');
  link.href = url;
  link.download = filename || 'printout.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function revokePdfUrl(url) {
  try {
    window.URL.revokeObjectURL(url);
  } catch (e) { /* already revoked */ }
}
